import Header from "../../Components/Header/Header";
import ListSearchForm from "../../Components/ListSearchForm/ListSearchForm";
function ListSearchPage() {
    return (
        <>
            <Header />
            <ListSearchForm />
        </>
    )
}

export default ListSearchPage;